export default __webpack_public_path__ + "static/portfolio-7b933a20e919039b636ee832060cdb1b.mp4";